<div class="digital-platform-input-wrapper">
  <label
    *ngIf="value && value.length > 0"
    [for]="name"
    class="digital-platform-input-label {{ variant }}"
    >{{ placeholder }}</label
  >
  <img
    *ngIf="iconLeft"
    class="icon-left"
    alt="{{ iconLeft }} icon"
    src="/assets/icons/{{ iconLeft }}.svg"
    [ngClass]="{ active: value && value.length > 0 }"
  />
  <img
    *ngIf="iconRight"
    class="icon-right"
    alt="{{ iconRight }} icon"
    src="/assets/icons/{{ iconRight }}.svg"
    [ngClass]="{ active: value && value.length > 0 }"
  />
  <input
    *ngIf="!large"
    type="text"
    [placeholder]="placeholder"
    [value]="value"
    [name]="name"
    [id]="id"
    [disabled]="control?.disabled"
    (keyup)="setValue($event)"
    [style.fontSize]="fontSize"
    [ngClass]="{
      'with-icon-left': iconLeft,
      'with-icon-right': iconRight,
      'ng-dirty': control?.dirty,
      'ng-invalid': isTouchedAndInvalid(),
      'ng-pristine': control?.pristine,
      'ng-touched': control?.touched,
      disabled: control?.disabled,
      'ng-required': required,
      active: value && value.length > 0
    }"
    class="digital-platform-input form-control {{ variant }} {{
      bg
    }} shadow-none"
    (blur)="onBlur()"
  />
  <textarea
    *ngIf="large"
    [placeholder]="placeholder"
    [value]="value"
    [name]="name"
    [id]="id"
    [disabled]="control?.disabled"
    (keyup)="setValue($event)"
    [ngClass]="{
      'ng-dirty': control?.dirty,
      'ng-invalid': isTouchedAndInvalid(),
      'ng-pristine': control?.pristine,
      'ng-touched': control?.touched,
      disabled: control?.disabled,
      'ng-required': required,
      active: value && value.length > 0,
      'large-text': large
    }"
    class="digital-platform-input form-control {{ variant }} shadow-none"
    data-automation-id="largeFieldFormInput"
    (blur)="onBlur()"
  ></textarea>
  <div *ngIf="isTouchedAndInvalid()" class="invalid-container">
    <img
      class="invalid-icon"
      alt="invalid"
      src="/assets/icons/triangle-exclamation.svg"
    />
    <small class="error-message" data-automation-id="errorMessage">{{
      errorMessage
    }}</small>
  </div>
</div>
